import _objectWithoutProperties from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/usr/src/app/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _excluded = ["items"];

var _templateObject, _templateObject2;

import React, { Fragment } from "react";
import { bool, func, string } from "prop-types";
import Styled from "styled-components"; // Colors

import { backgrounds, extended, primary } from "@uprise/colors"; // spacing

import { spacing } from "@uprise/spacing";
var ListStyles = Styled.ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      margin-left: 0;\n      margin-top: 0;\n      padding-left: 0;\n      margin-bottom: ", ";\n\n      display: flex;\n\tflex-direction: column;\n\tflex-wrap: wrap; \n"])), spacing.s6);
var ItemStyles = Styled.li(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      margin-bottom: 5px;\n      font-size: 15px;\n      color: ", ";\n      margin-bottom: ", ";\n      line-height: 24px;\n      list-style: none;\n      text-indent: -25px;\n      margin-left: 25px;\n      \n      &:before {\n            content: \"\u2022\";\n            font-size: 25px;\n            top: 3px;\n            position: relative;\n            color: ", ";\n            margin-right: 16px;\n      }\n"])), extended.charcoal.one, spacing.s3, primary.purple);
export var List = function List(_ref) {
  var items = _ref.items,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ListStyles, props, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ItemStyles, {
      key: index
    }, item.title);
  }));
}; // array, bool, func, number, object, string
// symbol, node, element, elementType
// instanceOf oneOf oneOfType shape, exact, func, any

List.propTypes = {
  className: string,
  color: string,
  width: string,
  textAlign: string
};
List.defaultProps = {
  className: "",
  color: primary.charcoal,
  width: "",
  textAlign: ""
};